import React from 'react';
import {COLORS} from '../../../../../constants/colors';
import {Icon, IconSize} from '../../../../atoms/Icon/Icon';
import {GenericIconName} from '../../../../atoms/Icon/IconName';

export const AboutYouKnob: React.FC<{
  className?: string;
  color?: keyof typeof COLORS;
  size?: keyof typeof IconSize;
}> = ({className, color = 'White', size = 'XSS'}) => (
  <Icon
    className={className}
    asset={GenericIconName.AboutYouKnob}
    size={size}
    fill={color}
  />
);

export const AboutYouHeartIcon: React.FC<{
  className?: string;
  color?: keyof typeof COLORS;
}> = ({className, color = 'White'}) => (
  <Icon
    className={className}
    asset={GenericIconName.HeartFilled}
    size="XS"
    fill={color}
  />
);
